export default __webpack_public_path__ + "static/media/group3.6f392703.jpg";